import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useLocaleState } from '@merchant-portal/merchant-portal-base'
import { Switch } from '@resurs/midas-react'
import { midas } from '@resurs/midas'
import { useToggle } from '../../../../../util/utility-hooks'
import { getText } from '../../../../../internal/TextLabels'
import TextInput from '../../../../../midasComponents/components/TextInput'
import { format } from '../../../../../models/format'
import { Languages } from '../../../../../models/languages'

export const EmailOrPhoneLink = props => {
  const [email, setEmail] = useState(props.email)
  const [phoneNumber, setPhoneNumber] = useState(props.phoneNumber)
  const [smsChecked, toggleSmsChecked] = useToggle(props.requirePhoneNumber)
  const [emailChecked, toggleEmailChecked] = useToggle(props.requireEmail)
  const [phoneValid, setPhoneValid] = useState(false)
  const [emailValid, setEmailValid] = useState(false)
  const { language } = useLocaleState()

  const update = () => {
    const valid =
      (smsChecked && phoneValid && (!emailChecked || emailValid)) ||
      (emailChecked && emailValid && (!smsChecked || phoneValid))
    const emailRequested = !!(emailChecked && emailValid && email)
    const smsRequested = !!(smsChecked && phoneValid && phoneNumber)
    props.onChange({
      email,
      mobile: phoneNumber,
      valid,
      emailRequested,
      smsRequested,
    })
  }

  useEffect(update, [
    smsChecked,
    emailChecked,
    phoneValid,
    emailValid,
    phoneNumber,
    email,
  ])

  const setWidthBasedOnLanguage = () =>
    language === Languages.FINNISH ? 150 : 110

  // eslint-disable-next-line react/no-unstable-nested-components
  const Label = textKey => (
    <div className={midas.formGroup} style={{ width: 75 }}>
      <label className={midas.formSwitch} style={{ paddingLeft: 0 }}>
        <strong>{getText(textKey)}</strong>
      </label>
    </div>
  )

  return (
    <>
      <div style={{ display: 'flex', marginTop: 20 }}>
        {props.requireEmail ? (
          Label('payApply.sign.digitalAgreement.email')
        ) : (
          <div style={{ width: setWidthBasedOnLanguage() }}>
            <Switch
              id="emailSwitch"
              boldText
              text={getText('payApply.sign.digitalAgreement.email')}
              checked={emailChecked}
              onChange={toggleEmailChecked}
            />
          </div>
        )}
        <TextInput
          id="emailInput"
          value={email}
          onChange={e => setEmail(e.target.value)}
          style={{ flexGrow: 1 }}
          format={format.email}
          isValid={({ valid }) => setEmailValid(valid)}
          disabled={!emailChecked}
          required={emailChecked ? getText('default.form.required') : ''}
        />
      </div>
      <div style={{ display: 'flex' }}>
        {props.requireEmail ? (
          Label('payApply.sign.digitalAgreement.sms')
        ) : (
          <div style={{ width: setWidthBasedOnLanguage() }}>
            <Switch
              id="smsSwitch"
              boldText
              text={getText('payApply.sign.digitalAgreement.sms')}
              checked={smsChecked}
              onChange={toggleSmsChecked}
            />
          </div>
        )}
        <TextInput
          id="phoneNumberInput"
          value={phoneNumber}
          onChange={e => setPhoneNumber(e.target.value)}
          style={{ flexGrow: 1 }}
          format={format.phone}
          isValid={({ valid }) => setPhoneValid(valid)}
          disabled={!smsChecked}
          required={smsChecked ? getText('default.form.required') : ''}
        />
      </div>
    </>
  )
}

EmailOrPhoneLink.propTypes = {
  email: PropTypes.string,
  phoneNumber: PropTypes.string,
  requirePhoneNumber: PropTypes.bool,
  requireEmail: PropTypes.bool,
  onChange: PropTypes.func,
}

EmailOrPhoneLink.defaultProps = {
  email: '',
  phoneNumber: '',
  requirePhoneNumber: false,
  requireEmail: false,
  onChange: () => {},
}
